
import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import RelayClosed from "@/components/relays/RelayClosed.vue";
import { mixins } from "vue-class-component";
import DocumentMixin from "@/mixins/DocumentMixin.vue";

@Component({
  components: {
    RelayClosed,
  },
})
export default class RelaysAutocomplete extends mixins(DocumentMixin) {

  @Prop({default: null})
  public companyId: number;

  private relays: any[] = [];
  private selectedRelayId: number = null;
  private search: string = null;
  private loading: boolean = false;
  private firstLoad: boolean = true;

  @Watch("companyId")
  public handlerCompanyId(newVal, oldVal) {
    if (newVal) {
      this.getAgencyRelays();
    }
  }

  @Watch("search", {immediate: true})
  public handlerSearchAgencyRelays() {
    this.getAgencyRelays();
  }

  get selectedRelay(): any {
    return this.relays.find((r) => r.id === this.selectedRelayId);
  }

  private clear(): void {
    this.selectedRelayId = null;
    this.search = null;
    this.emitChange();
  }

  private selectRelay(relayId: number): void {
    this.selectedRelayId = relayId;
    this.search = null;
    this.emitChange();
  }

  private emitChange() {
    this.blurElementById("relays-autocomplete-component");
    this.$emit("change", {
      selectedRelay: this.selectedRelay,
    });
  }

  private getAgencyRelays(): void {
    this.loading = true;
    this.$store.dispatch("companies/getRelays", {
      companyId: this.companyId,
      query: {
        search: this.search,
        itemsPerPage: 10,
      },
    }).then((res) => {
      this.relays = res.rows;
      if (this.relays.length === 1 && this.firstLoad) {
        this.selectedRelayId = this.relays[0]?.id;
        this.emitChange();
        // To prevent from auto-selecting when user clear search
        this.firstLoad = false;
      }
    }).finally(() => {
      this.loading = false;
    });
  }

}
